<template>
  <div class='pb-2'>
    <b-modal :visible="showbox" size="md" @show='showfunc' @hide='showbox=false' @ok='importEle'>
      <template #modal-header>
        <h5 class='mb-0'>選擇加入項目</h5>
      </template>
      <template>
        <div class='w-100 border-bottom pb-1'>
          <div class='d-flex'>
            <div class='d-flex align-items-center flex-fill'>
              <div class='px-2 text-nowrap'>大分類</div>
              <b-select size='sm' v-model='search.class1'>
                <option value="">無</option>
              </b-select>
            </div>
            <div class='d-flex align-items-center flex-fill'>
              <div class='px-2 text-nowrap'>小分類</div>
              <b-select size='sm' v-model='search.class2'>
                <option value="">無</option>
              </b-select>
            </div>
          </div>
          <b-row class='mt-1'>
            <b-col class='d-flex align-items-center'>
              <div class='px-2 text-nowrap'>關鍵字</div>
              <b-input size='sm' v-model='search.keywork'></b-input>
            </b-col>
          </b-row>
          <div class='mt-1'>
            <button class='btn btn-sm btn-primary w-100' @click='searchEle'>搜尋</button>
          </div>
        </div>
        <div class='mt-2 w-100'>

          <b-nav tabs>
            <b-nav-item :active='selectTag=="search"' @click='selectTag="search"'>搜尋</b-nav-item>
            <b-nav-item :active='selectTag=="select"' @click='selectTag="select"'>選取 <b-badge>
                {{selectlist.length}}</b-badge>
            </b-nav-item>
          </b-nav>
          <div v-if='selectTag=="select"'>
            <table class='table table-bordered'>
              <thead>
                <tr>
                  <th></th>
                  <th>項目代碼</th>
                  <th>項目名稱</th>
                  <th>大分類</th>
                  <th>小分類</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for='(item,$index) in selectlist' >
                  <td>
                      {{$index+1}}
                    <button class='btn btn-sm btn-primary' v-if='!checkselect(item.uid)'
                      @click='inviteitem(item)'>加入</button>
                    <button class='btn btn-sm btn-danger' v-else
                      @click='removeitem(item)'>移除</button>
                  </td>
                  <td>{{item.code}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.class1}}</td>
                  <td>{{item.class2}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else-if='selectTag=="search"'>
            <table class='table table-bordered'>
              <thead>
                <tr>
                  <th></th>
                  <th>項目代碼</th>
                  <th>項目名稱</th>
                  <th>大分類</th>
                  <th>小分類</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for='(item,$index) in elelist' :key='"ELE___"+item.uid'>
                  <td>
                    <button class='btn btn-sm btn-primary' v-if='!checkselect(item.uid)'
                      @click='inviteitem(item)'>加入</button>
                    <button class='btn btn-sm btn-danger' v-else
                      @click='removeitem(item)'>移除</button>
                  </td>
                  <td>{{item.code}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.class1}}</td>
                  <td>{{item.class2}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template #modal-footer='{ok,cancel}'>
        <button type='button' class='btn btn-sm btn-primary' @click='ok'>確定</button>
        <button type='button' class='btn btn-sm btn-danger' @click='cancel'>關閉</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import ctrl from './selectEle.js'
  export default ctrl;

</script>
